import { getDataFromApi } from './artistutils'
import { favouritesEl } from './favourites'

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import '../css/blocks/ArtistSlider.css'

(async function () {
    const artistsliders = document.querySelectorAll(".artistslider")
    if (artistsliders.length > 0) {
        const artists = await getDataFromApi("ArtistApi", "artistssummary", "")
        //console.log(artists)
        artistsliders.forEach(slider => {
            var swiperhtml = getSwiperHTML(slider, artists, 15)
            slider.innerHTML = swiperhtml
            const swiperEl = slider.querySelector(".swiper")

            favouritesEl.updateDom()

            swiperEl.querySelectorAll(".artist-itinerary").forEach(it => {
                it.querySelectorAll("img").forEach(img => {
                    img.addEventListener("click", (e) => {
                        e.preventDefault()
                        const artistEl = img.closest(".artist");
                        const artistid = parseInt(artistEl.dataset.artistid)
                        const artistName = artistEl.dataset.name
                        if (img.classList.contains("selected")) {
                            favouritesEl.removeFavourite(artistid)
                            favouritesEl.removeFavouriteClickEvent(artistName)
                        } else {
                            favouritesEl.addFavourite(artistid)
                            favouritesEl.addFavouriteClickEvent(artistName)
                        }
                    })
                })
            })

            const swiper = new Swiper(swiperEl, {
                modules: [Navigation],
                speed: 0,
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3
                    }
                }
            })
        })
    }

    function getSwiperHTML(slider, data, index) {
        var result = "";
        console.log(data[0])
        for (var idx = 0; idx < index && idx < data.length; idx++) {
            var artist = data[idx];
            var element = getSlidehtml(slider, artist);
            result += "<div class=\"swiper-slide\">" + element + "</div>";
        }
        result = `<div class="swiper">
            <div class="swiper-wrapper">
                ${result}
            </div>
            ${getPrevEl()}
            ${getNextEl()}
        </div>`;
        return result;
    }
    function getNextEl() {
        return `<div class=\"swiper-button swiper-button-next\">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/></svg>
        </div>`
    }
    function getPrevEl() {
        return `<div class="swiper-button swiper-button-prev">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z"/></svg>
        </div>`
    }


    function getSlidehtml(slider, artist) {
        //console.log(artist)
        let result = "";
        const baseUrl = slider.dataset.artistpageurl + "?artist=";
        if (artist && artist.logo) {
            //const bgpos = artist.focalTop ? `${artist.focalTop * 100}% 50%` : "center"
            const bg = `<div class="bg" style="background-image:url('${artist.logo}');"></div>`;
            const locationDiv = `<div class="location">${artist.artisticMedium} | ${artist.location}</div>`;
            const itinerary1 = `<img title="Remove from favourites" src="/img/ArtsTrail/heart/heart-16.svg" class="selected" width="16" height="16" alt="Not Selected" >`;
            const itinerary2 = `<img title="Add to favourites" src="/img/ArtsTrail/heart/heart-16-outlinewhite.svg" width="16" height=16 class="unselected" alt="Selected" >`;
            //const artistItinerry = `<div class="artist-itinerary"></div>`
            const itineraryDiv = `<div class="artist-itinerary wishlist logo">${itinerary1}${itinerary2}</div>`;
            const titleDiv = `<div class="title">${locationDiv}${itineraryDiv}</div>`;
            const nameDiv = `<div class="name">${artist.name}</div>`;
            const contentDiv = `<div class="content">${titleDiv}${nameDiv}</div>`;
            const innerContentDiv = `<div class="inner-content">${contentDiv}</div>`;
            const slideLink = `<a class="artist" data-artistid="${artist.id}" href="${baseUrl}${artist.nameInUrl}" data-name="${artist.name}">${innerContentDiv}</a>`
            const slideInnerDiv = `<div class="slide-inner">${bg}${slideLink}</div>`;
            result = slideInnerDiv;
        }
        return result;
    }
})()
